export interface ISaveOpportunityLanguage {
  code: string;
  name: string;
  fluency: string;
}

export class SaveOpportunityLanguage {
  public code: string;
  public name: string;
  public fluency: string;

  constructor(data: ISaveOpportunityLanguage) {
    this.code = data.code;
    this.name = data.name;
    this.fluency = data.fluency;
  }
}
